import { variants } from './tile-variants'

const TileComparable = ({ variant, ...props }) => {
	const Tile = variants[variant ?? 'base']
	return <Tile {...props} />
}

export default TileComparable
